<template>
  <v-card class="mt-3">
    <v-card-title>
      <div>
        <div class="headline">Promotion Rates</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review remove @review="doReview(props.item)" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Add Promotion Rate
        <v-icon right>mdi-sale</v-icon>
      </v-btn>
    </v-card-text>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Promotion Rate?
      <div class="title">{{deletePromoRateInfo}}</div>
      <div class="title">{{deletePromoRate}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { PROMOTION_PROMOFACT_TABMENU } from '@/store/types'

export default {
  data() {
    return {
      columns: [
        { text: 'Commission Gross/Net', align: 'left', value: 'commGN', sortable: false },
        { text: 'Commission %', align: 'left', value: 'commPct', sortable: false },
        { text: 'Discount %', align: 'left', value: 'discPct', sortable: false },
        { text: 'Factor 1', align: 'left', value: 'fact1', sortable: false },
        { text: 'Factor 2', align: 'left', value: 'fact2', sortable: false },
        { text: 'Factor 3', align: 'left', value: 'fact3', sortable: false },
        { text: 'Factor 4', align: 'left', value: 'fact4', sortable: false },
        { text: 'Factor 5', align: 'left', value: 'fact5', sortable: false },
        { text: 'Factor 6', align: 'left', value: 'fact6', sortable: false },
        { text: 'Protect Commission', align: 'left', value: 'protComm', sortable: false },
        { text: 'Protect Discount', align: 'left', value: 'protDisc', sortable: false }
      ],
      selectedColumns: [ 'commGN', 'commPct', 'discPct', 'fact1', 'fact2', 'fact3', 'fact4', 'fact5', 'fact6' ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedPromoRate: undefined,
      deletePromoRate: '',
      deletePromoRateInfo: ''
    }
  },
  computed: {
    promoFactorProduct() {
      return this.$store.state.promotionManagement.promotion.promoFactorProduct
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'promoRates': function(value) {
      this.items = value
    }
  },
  methods: {
    doReview(data) {
      const commitData = {
        promoFactTab: 2,
        displayFactReviewTab: true,
        displayRateTab: true
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'rateReview', params: { rateId: data } })
    },
    doNew() {
      const commitData = {
        promoFactTab: 2,
        displayFactReviewTab: true,
        displayRateTab: true
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'rateReview', params: { product: this.promoFactorProduct, rateId: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPromoRate = data
        this.deletePromoRate = data.fact1 + ' / ' + data.fact2 + ' / ' + data.fact3 + ' / ' + data.fact4 + ' / ' + data.fact5 + ' / ' + data.fact6
        this.deletePromoRateInfo = data.commGN + ' / Comm:' + data.commPct + '%' + ' / Disc:' + data.discPct + '%'
      }
    },
    doRemove() {
      this.$emit('doRemove', this.selectedPromoRate)
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    promoRates: {
      type: Array,
      default: () => []
    }
  },
  created() {
    if (this.promoRates && this.promoRates.length > 0) {
      this.items = this.promoRates
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
